<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Chats</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-item [button]="true" detail="false" color="lightmimbo" routerLink="chatbot">
          <ion-avatar slot="start" class="chatbot-avatar">
            <img src="../../assets/images/MimboLogo.png" class="chatbot-img" />
          </ion-avatar>
          <ion-label>
            <strong>Chat with Mimbo Bot</strong>
            <p>Get instant answers to your questions about pet care, health, and more!</p>
          </ion-label>
          <div class="metadata-end-wrapper" slot="end">
            <ion-icon color="medium" name="chevron-forward"></ion-icon>
          </div>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isLoading || !isSignedIn">
      <ion-col>
        <div class="ion-text-center ion-padding" *ngIf="isLoading">
          <ion-spinner color="primary"></ion-spinner>
        </div>
        <div class="ion-text-center ion-padding" *ngIf="!isLoading && !isSignedIn">
          <ion-text color="darkmimbo">You need to <a color="primary" routerLink="/signin"><b>sign in</b></a> to see your
            chats</ion-text>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!isLoading && isSignedIn">
      <ion-col>
        <ion-list *ngIf="threads.length; else empty" color="lightmimbo">
          <ion-item-sliding *ngFor="let t of threads">
            <ion-item button detail="true" (click)="open(t.id)" color="lightmimbo">
              <ion-avatar slot="start">
                <div class="avatar">{{ initials(t.otherName) }}</div>
              </ion-avatar>
              <ion-label>
                <h2>{{ t.otherName }}</h2>
                <p class="truncate">{{ t.lastMessage || ' ' }}</p>
              </ion-label>
              <ion-badge *ngIf="t.unreadMine > 0" color="primary">{{ t.unreadMine }}</ion-badge>
              <ion-note slot="end" class="time">{{ time(t.lastMessageAt) }}</ion-note>
            </ion-item>
            <ion-item-options>
              <ion-item-option color="danger" (click)="hideChat(t.id)"><ion-icon name="eye-off-outline"
                  slot="start"></ion-icon>Hide</ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-list>
      </ion-col>
      <ng-template #empty>
        <ion-text color="medium" class="empty-text">
          <div class="empty">No conversations yet.</div>
        </ion-text>
      </ng-template>
    </ion-row>
  </ion-grid>
</ion-content>